import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import ViewIntro from '../../components/ViewIntro'

export default {
  name: 'ContactMessageRead',
  data,
  methods,
  mounted,
  components: {
    ViewIntro,
  },
}
